import React from 'react';
import {
    Drawer, Box, Typography, IconButton, Divider, Stack, Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const RightDrawer = ({ open, onClose, title, children, onSave, onCancel }) => {
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ width: 400, height: '100vh', display: 'flex', flexDirection: 'column' }}>

                {/* Header */}
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 1.5,
                        backgroundColor: '#1e2a38',
                        color: 'white',
                    }}
                >
                    <Typography variant="h6">{title}</Typography>
                </Box>

                <Divider />

                {/* Body */}
                <Box
                    sx={{
                        flexGrow: 1,
                        p: 2,
                        overflowY: 'auto',
                    }}
                >
                    {children}
                </Box>

                {/* Footer */}
                <Divider />
                <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{
                        p: 1.5,
                        backgroundColor: '#e3eaf2', // Muted cool-tone gray-blue
                        borderTop: '1px solid #ccc',
                    }}
                >
                    <Button variant="outlined" onClick={onCancel || onClose}>
                        Cancel
                    </Button>
                    <Button variant="outlined" onClick={onSave}>
                        Save
                    </Button>
                </Stack>
            </Box>
        </Drawer>
    );
};

export default RightDrawer;
